import { IPregunta, Pregunta } from './pregunta.model';

export interface IOpcion {
  idPregunta: string;
  idRespuesta?: string;
  respuesta: string;
  permiteTexto: boolean;
  preguntas?: IPregunta[];
}

export class Opcion {

  idPregunta: string;
  idRespuesta?: string;
  respuesta: string;
  permiteTexto: boolean;
  respuestaTexto: string = '';
  preguntas: Pregunta[];

  constructor(model: IOpcion) {
    this.idPregunta = model.idPregunta;
    this.idRespuesta = model.idRespuesta;
    this.respuesta = model.respuesta;
    this.permiteTexto = model.permiteTexto;
    this.preguntas = model.preguntas 
      ? model.preguntas.map(
          p => new Pregunta(p)
        ) 
      : [];
  }

}
